import React from 'react';
import { Box, Typography } from '@mui/material';

const VersionInfo: React.FC = () => {
  let frontendVersion = (window as any).__APP_VERSIONS__?.frontend || '1.0.0';
  let backendVersion = (window as any).__APP_VERSIONS__?.backend || '0.0.1';

  console.log('frontendVersion', frontendVersion);
  console.log('backendVersion', backendVersion);

  if (frontendVersion === '{{THIS_WILL_BE_UPDATED_AT_BUILD_TIME_BY_A_POSTBUILD_SCRIPT}}') {
   return null;
  }
  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mr: 2,
        minWidth: '80px'
      }}
    >
      <Typography 
        variant="caption" 
        sx={{ 
          fontSize: '0.7rem',
          color: 'rgba(255, 255, 255, 0.7)',
          lineHeight: 1.2,
          textAlign: 'center'
        }}
      >
        FE: v{frontendVersion}
      </Typography>
      <Typography 
        variant="caption" 
        sx={{ 
          fontSize: '0.7rem',
          color: 'rgba(255, 255, 255, 0.7)',
          lineHeight: 1.2,
          textAlign: 'center'
        }}
      >
        BE: v{backendVersion}
      </Typography>
    </Box>
  );
};

export default VersionInfo;